var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wysiwyg',_vm._g(_vm._b({ref:"wysiwyg",attrs:{"extensions":_vm.$options.extensions},scopedSlots:_vm._u([{key:"menubar",fn:function({ editor }){return [_c('menubar',{attrs:{"editor":editor,"invalid":_vm.invalid,"disabled":_vm.disabled}})]}}])},'base-wysiwyg',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }